import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCases } from "../api/caseService";

// Maps raw backend status codes to friendly, layman-facing labels.
const statusLabel = (status) => {
  const map = {
    SUCCESS: { text: "Verified", cls: "status-success" },
    PENDING: { text: "In Progress", cls: "status-pending" },
    FAILED: { text: "Needs Attention", cls: "status-failed" },
  };
  return map[status] || { text: status || "Unknown", cls: "status-pending" };
};

export default function EkycOverview() {
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    getCases()
      .then((res) => setCases(res.data || []))
      .catch(() => setErrorMsg("Unable to load your eKYC records right now."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <div>
          <h2 style={{ margin: 0, color: "#0b2545" }}>eKYC Verification Overview</h2>
          <p style={{ color: "#6b7280", margin: "4px 0 0" }}>
            Track the identity verification status for each expert linked to your account.
          </p>
        </div>
      </div>

      <div className="card">
        {loading && <p>Loading your records...</p>}
        {!loading && errorMsg && <p className="form-error">{errorMsg}</p>}
        {!loading && !errorMsg && cases.length === 0 && (
          <p style={{ color: "#6b7280" }}>No eKYC records found yet.</p>
        )}

        {!loading && !errorMsg && cases.length > 0 && (
          <table className="data-table">
            <thead>
              <tr>
                <th>Expert Name</th>
                <th>Mobile Number/WeChat ID</th>
                <th>Verification Status</th>
                <th>Submitted On</th>
                <th>Last Updated</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {cases.map((c) => {
                const s = statusLabel(c.status);
                return (
                  <tr key={c.case_id}>
                    <td>{c.expert_name || "-"}</td>
                    <td>{c.wechat_id || "-"}</td>
                    <td>
                      <span className={`status-badge ${s.cls}`}>{s.text}</span>
                    </td>
                    <td>{c.created_at ? new Date(c.created_at).toLocaleDateString() : "-"}</td>
                    <td>{c.updated_at ? new Date(c.updated_at).toLocaleDateString() : "-"}</td>
                    <td>
                      <Link to={`/ekyc/${c.case_id}`} style={{ color: "#0b2545", fontWeight: 600 }}>
                        View details
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
